/**
 * useDeleteVideo Hook
 * Deletes a profile video (soft delete + Cloudflare/GCS cleanup) via the
 * native pipeline.
 */

import { useMutation, useQueryClient } from "@tanstack/react-query"
import { deleteProfileVideo } from "../services/profileVideo.service"

export function useDeleteVideo() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ userId, videoId }: { userId: string; videoId: string }) =>
      deleteProfileVideo(userId, videoId),
    onSuccess: async (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ["video", variables.userId] })
    },
  })
}
